import { ICPlatformVersion } from '@retailer-platform/dashboard/access-control'
import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'

export const retailerFundedMarketingWholesalerAccessControl: DomainAccessControlConfig = [
  {
    permissions: [Permission.RetailerFundedMarketingRetailerFundedMarketingAdminAccess],
  },
  {
    warehouseFeatureToggles: [FeatureToggle.wholesalerCampaignsEnabled],
    permissions: [
      Permission.RetailerFundedMarketingRetailerFundedMarketingViewAccess,
      Permission.RetailerFundedMarketingRetailerFundedMarketingInsights,
    ],
    notFeatureToggles: [FeatureToggle.retailerFundedMarketingUserDenyList],
    minICPlatformVersion: ICPlatformVersion.r2025_11_0,
  },
]
